import { cleanUrlParam } from './cleanUrlParam';

export function addQueryStringParam(key, value) {
    return value ? `?${key}=${cleanUrlParam(decodeURIComponent(value))}` : "";
}